import React, { Component } from 'react';
import { Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';

import TransferModal from './transferModal'
import NavbarComponent from '../../Navbar/index';
import RenovateTokenAlert from '../../../RenovateToken';
import Backend from '../../../Backend';
import Connection from '../../../Calls';

import BackArrow from '../../../Images/arrow-left.svg';

import './index.css';



function formatMoney(n,c,d,t){
var n = n,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-$" : "$",
    i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
    j = (j = i.length) > 3 ? j % 3 : 0;
   return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
 };

let info = {email:'E-mail',coin:'Crypto',address:'Address'}
class EcommerceWallets extends Component {
  constructor(props) {
    super(props)
    this.state = {
      wallets:[],
      show:false,
      coin:'btc'
    }
  }

  componentDidMount(){
    this.getWalletInfo()
    this.getCoins()
  }

  getWalletInfo(){
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {

      Backend.general_get('get_ecomm_wallets',response.payload.r01,response=>{
        if(response.status.code == '0'){
          this.setState({ ...response.payload})
        }
      });

      Backend.GroupInformationPlanInfo(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
        if (response.status.code === "0") {
          this.setState({
            planInfo: response.payload.plan,
            coinsInfo: response.payload.coins,
          });
        }
      });
    })
  }

  getCoins() {
    const self = this;
    Backend.DropdownCoin(response => {
      if (response.status.code === "0") {
        self.setState({
          coins: response.payload,
        });
      }
    });
  }
  renderListCoins(value) {
    var item;
    this.state.coins.forEach(element => {
      if (element.symbol.toLowerCase() === value.toLowerCase()) {
        item = element.name;
      }
    });
    return item;
  }

  renderListWallets() {
    const self = this;
    var users = [];
    self.state.wallets.forEach(function (row) {
      var result = self.renderListCoins(row.coin);
      // <tr className="hover-tr-table-wallets-generals" onClick={() => { self.redirectInformationWallet(row.id_wallet, row.coin) }}>
      users.push(
        <tr className="hover-tr-table-wallets-generals">
          <th className="table-wallet-text-result"><Image src={require("../../../CryptoIcons/" + row.coin + ".svg")} className="icon-crypto-svg" /> {result} </th>
          <th className="table-wallet-text-alias">{row.alias}</th>
          <th className="table-wallet-text-balance">{row.balance}</th>
        </tr>
      );
    });
    return users;
  }

  render(){
    let { ecomm } = this.props.traductions
    return(
      <div>
        <NavbarComponent data={this.props} selected="ecommerce" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10 }}>
          <Container className='ecommerce_signup'>
            <div>
              <div className='back-button' style={{width:110, cursor:'pointer', marginTop:-15, marginBottom:10}} onClick={()=>this.props.data.history.push('/ecommerce')}>
                <Image src={BackArrow} style={{ marginTop:-3, marginRight:10}}/>
                {ecomm.goBack}
              </div>
            </div>
            <span className='dark-text medium-dms text-25 title-wallet-responsive'>{ecomm.b_wallets}</span>
            <div className="responsive-kpi">
              <span className='dark-text medium-dms text-25 title-wallet'>{ecomm.b_wallets}</span>
              <div style={{display: 'flex'}}>
                <div className='card-kpi card-kpi-m-right'>
                  <span className='blue-indicator'>{formatMoney(this.state.sum_estimated_balances?.usd)}</span>
                  <span className='estimated-label'>{ecomm.estimated_usd}</span>
                </div>
                <div className='card-kpi'>
                  <span className='blue-indicator'>{formatMoney(this.state.sum_estimated_balances?.mxn)}</span>
                  <span className='estimated-label'>{ecomm.estimated_mxn}</span>
                </div>
              </div>
            </div>
            <div className='container-transactions'>
              <div style={{textAlign:'right'}}>
                <Button style={{marginRight:0}}className="wirebit-transfer-generals-button" variant="primary" onClick={() => { this.setState({show:true}); }}>Wirebit Transfer</Button>
              </div>

              <div style={{ height: "calc(100vh - 377px)" }} className="scroll-table-wallets-generals">
                <table className="table-container-wallets-generals">
                  <thead>
                    <tr>
                      <th className="header-table-wallets-generals fixxxed">{ecomm.coin}</th>
                      <th className="header-table-wallets-generals fixxxed">alias</th>
                      <th className="header-table-wallets-generals fixxxed align-text-right">balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.renderListWallets()}
                  </tbody>
                </table>
              </div>

            </div>
          </Container>
        </div>
        <TransferModal {...this.state} handleClose={()=>this.setState({show:false}) } refresher={()=>this.getWalletInfo()}/>

      </div>
    )
  }

}
export default EcommerceWallets
